"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const custom_filter_1 = require("components/atoms/custom-filter");
const HaulingStatisticColumnProps = [
    {
        show: true,
        field: 'ticket_no_silo',
        title: 'Ticket',
        width: '200',
        filter: 'text',
        filterable: true,
    },
    {
        show: true,
        field: 'contractor_code',
        title: 'Contractor',
        width: '150',
        filter: 'text',
        filterable: true,
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler',
        width: '100',
        filter: 'text',
        filterable: true,
    },
    {
        show: true,
        field: 'vessel_1_no',
        title: 'Vessel 1',
        width: '100',
        filter: 'text',
        filterable: true,
    },
    {
        show: true,
        field: 'vessel_1_capacity',
        title: 'Vessel 1 Capacity',
        width: '125',
        filter: 'numeric',
        filterable: true,
    },
    {
        show: true,
        field: 'vessel_2_no',
        title: 'Vessel 2',
        width: '100',
        filter: 'text',
        filterable: true,
    },
    {
        show: true,
        field: 'vessel_2_capacity',
        title: 'Vessel 2 Capacity',
        width: '125',
        filter: 'numeric',
        filterable: true,
    },
    {
        show: true,
        field: 'brand_name',
        title: 'Brand',
        width: '125',
        filter: 'text',
        filterable: true,
    },
    {
        show: true,
        field: 'driver_name',
        title: 'Driver',
        width: '150',
        filter: 'text',
        filterable: true,
    },
    {
        show: true,
        field: 'silo',
        title: 'Silo',
        width: 'auto',
        filterable: false,
        innerColumn: [
            {
                show: true,
                field: 'checkpoint_name_silo',
                title: 'Silo',
                width: '125',
                filter: 'text',
                filterable: true,
            },
            {
                show: true,
                field: 'main_entrance_in_silo',
                title: 'Main Entrance In',
                width: '150',
                filter: 'date',
                filterable: true,
                format: constants_1.formatGridDate.ddMMyyyyHHmm
            },
            {
                show: true,
                field: 'queue_time_silo',
                title: 'Queue Time',
                width: '125',
                filterCell: custom_filter_1.FilterTImePicker,
            },
            {
                show: true,
                field: 'time_in_silo',
                title: 'Time In',
                width: '150',
                filter: 'date',
                filterable: true,
                format: constants_1.formatGridDate.ddMMyyyyHHmm,
            },
            {
                show: true,
                field: 'time_out_silo',
                title: 'Time Out',
                width: '150',
                filter: 'date',
                filterable: true,
                format: constants_1.formatGridDate.ddMMyyyyHHmm,
            },
            {
                show: true,
                field: 'lead_time_silo',
                title: 'Lead Time',
                width: '175',
                filterable: true,
                filterCell: custom_filter_1.FilterTImePicker,
            },
        ]
    },
    {
        show: true,
        field: 'hopper',
        title: 'Hopper',
        width: 'auto',
        filterable: false,
        innerColumn: [
            {
                show: true,
                field: 'checkpoint_name_hopper',
                title: 'Hopper',
                width: '125',
                filterable: false,
            },
            {
                show: true,
                field: 'main_entrance_in_hopper',
                title: 'Main Entrance In',
                width: '150',
                filterable: false,
                format: constants_1.formatGridDate.ddMMyyyyHHmm
            },
            {
                show: true,
                field: 'queue_time_hopper',
                title: 'Queue Time',
                width: '125',
                filter: 'date',
            },
            {
                show: true,
                field: 'time_in_hopper',
                title: 'Time In',
                width: '150',
                filter: 'date',
                format: constants_1.formatGridDate.ddMMyyyyHHmm,
            },
            {
                show: true,
                field: 'time_out_hopper',
                title: 'Time Out',
                width: '150',
                filter: 'date',
                format: constants_1.formatGridDate.ddMMyyyyHHmm,
            },
            {
                show: true,
                field: 'lead_time_hopper',
                title: 'Lead Time',
                width: '175',
                filter: 'date',
            },
            {
                show: true,
                field: 'dumping_type',
                title: 'Dumping Type',
                width: '175',
                filter: 'text',
            }
        ]
    }
];
exports.default = HaulingStatisticColumnProps;
